$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
    if (jqxhr.status === 401) {
        document.location.href = '/';
    }
});
$.fn.select2.defaults.set( "theme", "bootstrap4" );

window.initComponents = function() {
    $('[data-toggle="popover"]').each((index, el) => {
        let conf = $.extend({
            "trigger": "hover",
            "container": "body",
            "placement": "left",
            "html": true
        }, $(el).data());

        $(el).popover('dispose')
        $(el).popover(conf);
    })

 $('[data-toggle="tooltip"]').tooltip({
            "trigger": "hover",
            "placement": "top",
            "delay": { show: 100, hide: 100 },
            "html": true,
            "container": "tr",
            "boundary": "window"
        });


    $("[id^='tooltip']").tooltip('hide');

    // $(".select2").select2();
    $('.select2').each(function(index, el){
        let conf = $.extend({}, $(el).data('config'));
        $(el).select2(conf);
    });

    $('.datepicker').each(function(index, el){
        let _this = $(el);

        // let format = $(el).attr('date-format');
        // format = format? format : "Y-m-d G:i K";

        let conf = $.extend({
            // enableTime: false,
            disableMobile: "true",
            dateFormat: 'Y-m-d',
        }, $(el).data('config'));

        if(typeof conf.altFormat == 'undefined') {
            conf.altFormat = conf.dateFormat;
        }

        flatpickr(el, conf);
    });

    $('.year-month-picker').each(function(index, el){
        let _this = $(el);
        let el_config = $(el).data('config');

        let conf = $.extend({
            shorthand: true, //defaults to false
            dateFormat: "F Y", //defaults to "F Y"
            altFormat: "F Y", //defaults to "F Y"
            // theme: "dark" // defaults to "light"
        }, el_config);

        let picker_config = {
            disableMobile: "true",
            plugins : [
                new monthSelectPlugin(conf)
            ]
        }

        flatpickr(el, picker_config);
    });
}

if(typeof debounce != 'function') {
    window.debounce = (func, timeout = 300) => {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }
}


window.dt_options = {

    "initComplete" : function(settings, data){
        initComponents();
    },

    "drawComplete" : function(settings, data){
        initComponents();
    },

    "serverSideExportAction" : function(e, dt, button, config) {
        var self = this;
        var oldStart = dt.settings()[0]._iDisplayStart;
        var oldText = $(button[0]).html();

        $(button[0]).html('<i class="fa fa-spinner fa-spin"></i>');

        dt.one('preXhr', function (e, s, data) {
            // Just this once, load all data from the server...
            data.start = 0;
            data.length = 2147483647;
            dt.one('preDraw', function (e, settings) {
                // Call the original action function
                if (button[0].className.indexOf('buttons-copy') >= 0) {
                    $.fn.dataTable.ext.buttons.copyHtml5.action.call(self, e, dt, button, config);
                } else if (button[0].className.indexOf('buttons-excel') >= 0) {
                    $.fn.dataTable.ext.buttons.excelHtml5.available(dt, config) ?
                        $.fn.dataTable.ext.buttons.excelHtml5.action.call(self, e, dt, button, config) :
                        $.fn.dataTable.ext.buttons.excelFlash.action.call(self, e, dt, button, config);
                } else if (button[0].className.indexOf('buttons-csv') >= 0) {
                    $.fn.dataTable.ext.buttons.csvHtml5.available(dt, config) ?
                        $.fn.dataTable.ext.buttons.csvHtml5.action.call(self, e, dt, button, config) :
                        $.fn.dataTable.ext.buttons.csvFlash.action.call(self, e, dt, button, config);
                } else if (button[0].className.indexOf('buttons-pdf') >= 0) {
                    $.fn.dataTable.ext.buttons.pdfHtml5.available(dt, config) ?
                        $.fn.dataTable.ext.buttons.pdfHtml5.action.call(self, e, dt, button, config) :
                        $.fn.dataTable.ext.buttons.pdfFlash.action.call(self, e, dt, button, config);
                } else if (button[0].className.indexOf('buttons-print') >= 0) {
                    $.fn.dataTable.ext.buttons.print.action(e, dt, button, config);
                }
                dt.one('preXhr', function (e, s, data) {
                    // DataTables thinks the first item displayed is index 0, but we're not drawing that.
                    // Set the property to what it was before exporting.
                    settings._iDisplayStart = oldStart;
                    data.start = oldStart;
                });
                // Reload the grid with the original page. Otherwise, API functions like table.cell(this) don't work properly.
                setTimeout(dt.ajax.reload, 0);
                // Prevent rendering of the full data to the DOM
                return false;
            });
        });
        // Requery the server with the new one-time export settings
        dt.ajax.reload(function () {
            $(button[0]).html(oldText);
        });
    }
}

window.addEventListener('initComponents',function () {
    initComponents();
})


$(document).ready(function(){

    $('.counter').each(function () {
        var $this = $(this);
        jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
            duration: 1000,
            easing: 'swing',
            step: function () {
                $this.text(Math.ceil(this.Counter));
            }
        });
    });

    initComponents();
});


$(document).on('shown.bs.popover', '[data-toggle="popover"]', function () {
    let el = this;

    setTimeout(function () {
        let closeEvent = $(el).data('close-event');
        let id = $(el).attr('aria-describedby');
        let replaceContent = $(el).attr('data-replace-content');

        if(id && $("#"+id).length > 0) {
            if(replaceContent) {
                $('.popover-body', $("#"+id)).html(replaceContent);
            }

            if(closeEvent) {
                $("#"+id).off(closeEvent);
                $("#"+id).on(closeEvent, function () {
                    $(el).popover('hide')
                })
            }
        }
    }, 10);
});

$(document).click(function (e) {

    let popoverEl = $(e.target).attr('data-toggle') == 'popover' ? $(e.target) : ($(e.target).parent().attr('data-toggle') == 'popover' ? $(e.target).parent() : null);

    if(popoverEl) {

        $('[data-toggle="popover"]').each(function () {
            if(popoverEl.attr('data-replace-content') != $(this).attr('data-replace-content')) {
                $(this).popover('hide')
            }
        })

        return;
    }

    let popover = $(e.target).hasClass('popover') ? $(e.target) : $(e.target).closest('.popover');

    if(popover.length > 0 || $(".popover.show").length == 0) {
        return;
    }

    let id = $(".popover.show").attr('id');
    let t = $("[aria-describedby=\"" + id + "\"]");

    if(id && t.length > 0 && typeof t.popover == 'function') {
        t.popover('hide')
    }
});

